const commonInputFields = [
  {
    name: "category",
    label: "Categoria",
    disabled: true,
  },
  {
    name: "className",
    label: "Classe",
    disabled: true,
  },
  {
    name: "subcategory",
    label: "Subclasse",
    disabled: true,
  },
];

const conservativeInputFields = [
  {
    name: "minConsAllocation",
    label: "Mínimo (Conservador)",
    type: "percentage",
    width: 230,
  },
  {
    name: "minConsUseDefault",
    label: "Utilizar valor padrão sugerido (Conservador)",
    type: "checkbox",
    width: 230,
  },
  {
    name: "recConsAllocation",
    label: "Recomendado (Conservador)",
    type: "percentage",
    width: 230,
    disabled: true,
  },
  {
    name: "maxConsAllocation",
    label: "Máximo (Conservador)",
    type: "percentage",
    width: 230,
  },
  {
    name: "maxConsUseDefault",
    label: "Utilizar valor padrão sugerido (Conservador)",
    type: "checkbox",
    width: 230,
  },
];

const moderateConservativeInputFields = [
  {
    name: "minConsModAllocation",
    label: "Mínimo (Mod-Conservador)",
    type: "percentage",
    width: 230,
  },
  {
    name: "recConsModAllocation",
    label: "Recomendado (Mod-Conservador)",
    type: "percentage",
    width: 230,
    disabled: true,
  },
  {
    name: "maxConsModAllocation",
    label: "Máximo (Mod-Conservador)",
    type: "percentage",
    width: 230,
  },
];

const moderateInputFields = [
  {
    name: "minModAllocation",
    label: "Mínimo (Moderado)",
    type: "percentage",
    width: 230,
  },
  {
    name: "recModAllocation",
    label: "Recomendado (Moderado)",
    type: "percentage",
    width: 230,
    disabled: true,
  },
  {
    name: "maxModAllocation",
    label: "Máximo (Moderado)",
    type: "percentage",
    width: 230,
  },
];

const moderateAggressiveInputFields = [
  {
    name: "minModAggrAllocation",
    label: "Mínimo (Mod-Arrojado)",
    type: "percentage",
    width: 230,
  },
  {
    name: "recModAggrAllocation",
    label: "Recomendado (Mod-Arrojado)",
    type: "percentage",
    width: 230,
    disabled: true,
  },
  {
    name: "maxModAggrAllocation",
    label: "Máximo (Mod-Arrojado)",
    type: "percentage",
    width: 230,
  },
];

const aggressiveInputFields = [
  {
    name: "minAggrAllocation",
    label: "Mínimo (Arrojado)",
    type: "percentage",
    width: 230,
  },
  {
    name: "minAggrUseDefault",
    label: "Utilizar valor padrão",
    type: "checkbox",
    width: 230,
  },
  {
    name: "recAggrAllocation",
    label: "Recomendado (Arrojado)",
    type: "percentage",
    width: 230,
    disabled: true,
  },
  {
    name: "maxAggrAllocation",
    label: "Máximo (Arrojado)",
    type: "percentage",
    width: 230,
  },
  {
    name: "maxAggrUseDefault",
    label: "Utilizar valor padrão",
    type: "checkbox",
    width: 230,
  },
];

const getWalletBalancingInputFields = (walletProfile) => {
  const inputFields = [
    ...commonInputFields,
    ...(walletProfile === "conservative" ? conservativeInputFields : []),
    ...(walletProfile === "mod_conservative"
      ? moderateConservativeInputFields
      : []),
    ...(walletProfile === "moderate" ? moderateInputFields : []),
    ...(walletProfile === "mod_aggressive"
      ? moderateAggressiveInputFields
      : []),
    ...(walletProfile === "aggressive" ? aggressiveInputFields : []),
  ];

  return inputFields;
};

export default getWalletBalancingInputFields;
